import React from 'react';
import { Helmet } from 'react-helmet-async';

// Static layout sections
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
// import MissionStatement from '../components/MissionStatement';
// import FeatureHighlights from '../components/FeatureHighlights';
// import CustomerConfidence from '../components/CustomerConfidence';
import Partners from '../components/Partners';
import HowItWorks from '../components/HowItWorks';
import SearchSpotlight from '../components/SearchSpotlight';
import Footer from '../components/Footer';
import ChatbotModal from '../components/ChatBotAi/ChatBotAi';

// Dynamic data sections
import TrendingProducts from '../features/TrendingProducts';
import TopCategories from '../features/TopCategories';
import CuratedSegments from '../features/CuratedSegments';

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>KambiHome - Global Supply, Commerce & Procurement</title>
        <meta
          name="description"
          content="KambiHome connects African consumers, businesses, and institutions to home and lifestyle products across multiple global supply corridors."
        />
        <meta
          name="keywords"
          content="KambiHome, global sourcing, African commerce, business procurement, home and lifestyle products, global supply corridors"
        />
        <link rel="canonical" href="https://kambihome.com/" />

        <meta property="og:title" content="KambiHome - Global Supply, Commerce & Procurement" />
        <meta
          property="og:description"
          content="Discover, shop, source, and procure home and lifestyle products through connected global supply corridors."
        />
        <meta property="og:image" content="https://kambihome.com/segments/seobanner.png" />
        <meta property="og:url" content="https://kambihome.com/" />
        <meta property="og:type" content="website" />

        <meta name="twitter:title" content="KambiHome - Global Supply, Commerce & Procurement" />
        <meta
          name="twitter:description"
          content="Connecting global home and lifestyle supply with African demand."
        />
        <meta name="twitter:image" content="https://kambihome.com/segments/seobanner.png" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <Header />
      <main className="mt-16 scroll-smooth">
        <HeroSection />
        {/* <MissionStatement /> */}
        <TrendingProducts />
        {/* <FeatureHighlights /> */}
        <TopCategories />
        {/* <CustomerConfidence /> */}
        <CuratedSegments />
        <HowItWorks />
        <SearchSpotlight />
        <Partners />
      </main>
      <Footer />
      <ChatbotModal />
    </>
  );
};

export default HomePage;
